<template>
    <div class="computerBox">
        <topBox :title="title" />
        <div class="px-[36px] w-full mt-[80px] pb-[90px]">

            <div class="hero-card">
                <div class="text-m14 font-semibold text-slate-900">{{ $t('treasurePlate.becomeTitle') }}</div>
                <p class="mt-2 fz12 text-slate-500 leading-relaxed">{{ $t('treasurePlate.becomeDesc') }}</p>
            </div>

            <div class="section-card mt-3">
                <div class="text-m14 font-semibold text-slate-900">{{ $t('treasurePlate.benefitTitle') }}</div>
                <p class="mt-2 fz12 text-slate-500 leading-relaxed">{{ $t('treasurePlate.benefitDesc') }}</p>
            </div>

            <div class="section-card mt-3">
                <div class="text-m14 font-semibold text-green-700">{{ $t('treasurePlate.directTitle') }}</div>
                <p class="mt-2 fz12 text-slate-500 leading-relaxed">{{ $t('treasurePlate.directTip') }}</p>
                <div class="mt-3 overflow-hidden rounded-[16px] border">
                    <div class="rank-row rank-row--head">
                        <span>{{ $t('treasurePlate.colRank') }}</span>
                        <span>{{ $t('treasurePlate.colAmount') }}</span>
                        <span>{{ $t('treasurePlate.colSlogan') }}</span>
                    </div>
                    <div
                        v-for="(item, index) in rankTiers"
                        :key="index"
                        class="rank-row"
                    >
                        <span class="font-medium text-slate-800">{{ item.title }}</span>
                        <span class="text-slate-600">{{ item.amount }}</span>
                        <span class="text-slate-400">{{ item.slogan }}</span>
                    </div>
                </div>
            </div>

            <div class="section-card mt-3">
                <div class="text-m14 font-semibold text-green-700">{{ $t('treasurePlate.teamTitle') }}</div>
                <p class="mt-2 fz12 text-slate-500 leading-relaxed">{{ $t('treasurePlate.teamIntro') }}</p>
                <ol class="mt-3 space-y-2 pl-4 fz12 text-slate-600 leading-relaxed list-decimal">
                    <li v-for="(rule, index) in teamRules" :key="index">{{ rule }}</li>
                </ol>
            </div>

            <div class="py-[12px] mt-2">
                <button
                    type="button"
                    class="block w-full px-3 py-[15px] border rounded-full butSubmit text-white shadow-lg focus:ring-1 focus:outline-none text-xs-xs"
                    @click="goBuyYear"
                >
                    {{ $t('treasurePlate.goBuyYear') }}
                </button>
            </div>

        </div>
        <mainMenu />
    </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import topBox from '@/components/computer/TopBox.vue'
import mainMenu from '@/components/computer/MainMenu.vue'

const RANK_KEYS = ['r1', 'r2', 'r3', 'r4', 'r5', 'r6', 'r7', 'r8', 'r9', 'r10']
const TEAM_RULE_KEYS = ['t1', 't2']


export default {
    components: {
        topBox,
        mainMenu,
    },
    data() {
        return {
            title: '',
            lang: '',
        }
    },
    computed: {
        rankTiers() {
            return RANK_KEYS.map((key) => ({
                title: this.$t(`treasurePlate.${key}.title`),
                amount: this.$t(`treasurePlate.${key}.amount`),
                slogan: this.$t(`treasurePlate.${key}.slogan`),
            }))
        },
        teamRules() {
            return TEAM_RULE_KEYS.map((key) => this.$t(`treasurePlate.${key}`))
        },
    },
    mounted() {
        const { locale } = useI18n()
        this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : locale.value
        locale.value = this.lang
        this.title = this.$t('page.treasurePlate')
    },
    methods: {
        goBuyYear() {
            this.$router.push({ path: '/recharge', query: { plan: 'year' } })
        },
    },
}
</script>

<style lang="scss" scoped>
.hero-card,
.section-card {
    border-radius: 24px;
    border: 1px solid #e5e7eb;
    background: #fff;
    padding: 20px 24px;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08);
}

.rank-row {
    display: grid;
    grid-template-columns: 1.1fr 1fr 1.1fr;
    gap: 8px;
    padding: 10px 12px;
    font-size: 12px;
    border-top: 1px solid #f1f5f9;

    &--head {
        border-top: none;
        background: #f8fafc;
        color: #64748b;
        font-weight: 600;
    }
}
</style>
